import { render, staticRenderFns } from "./TheLeaseIDTAddForm.vue?vue&type=template&id=0150fd35&"
import script from "./TheLeaseIDTAddForm.vue?vue&type=script&lang=js&"
export * from "./TheLeaseIDTAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports